import type { DefDialogState, DialogName } from '@/stores/useDialogStore';

import { useRouter } from 'vue-router';

import { useDialogStore } from '@/stores/useDialogStore';
import { buildCloneBookingRoute } from '@/helpers/advancedJobBooking';

export function useCloneJobDialog() {
  const router = useRouter();
  const dialogStore = useDialogStore();

  function open(jobId: number, jobDate: string, onConfirm?: () => void): void {
    const dialogName: DialogName = 'cloneJob';
    dialogStore
      .open(dialogName, { job: { jobId, jobDate } })
      .once(
        'closed',
        function (
          closeDetail: DefDialogState[typeof dialogName]['closeDetail'],
        ) {
          if (closeDetail !== 'confirm') return;
          onConfirm?.();
          void router.push(buildCloneBookingRoute(jobId, jobDate));
        },
      );
  }

  return {
    open,
  };
}
